import React from 'react';
import { useState, useEffect, useContext } from 'react'

import Paper from '@mui/material/Paper';
import { Modal, Button } from '@mui/material';

import Icon from '@mdi/react'
import { mdiQrcode } from '@mdi/js'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../AuthContext';

import {
  Grid,
  ThemeProvider,
  StyledEngineProvider,
  adaptV4Theme,
} from "@mui/material";

import MaterialTable from '@material-table/core';

import UserService from "../../services/user.service";
import { useStyles, theme, direction } from '../styles'; // Importa los estilos desde el archivo styles.js

import QRModal from "../QR/QRModal";

export default function Sucursales(props) {
  const [url, setUrl] = useState("");
  const [modalQR, setModalQR] = useState(false);

  const [isLoading, setIsLoading] = useState(false)
  const { showOwner, showUser, OwnedProducts } = useContext(AuthContext);
  const styles = useStyles();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [consolaSeleccionada, setConsolaSeleccionada] = useState({
    nombre: '',
    codigo: '',
  })

  const peticionGet = async () => {
    const result = await UserService.getSucursales();
    setData(result.data);
  }

  const peticionDelete = async () => {
    const response = await UserService.delSucursal(consolaSeleccionada.id);
    var data = response.data;
    setData(data.filter(consola => consola.id !== consolaSeleccionada.id));
    peticionGet();
    abrirCerrarModalEliminar();
  }

  const abrirCerrarModalInsertar = () => {
    props.history.push(process.env.PUBLIC_URL + "/sucursalesaddmod/")
  }

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  }

  const seleccionarConsola = (consola, caso) => {
    setConsolaSeleccionada(consola);
    (caso === 'Editar') ? props.history.push(process.env.PUBLIC_URL + "/sucursalesaddmod/" + consola.id) : abrirCerrarModalEliminar()
  }

  useEffect(() => {
    const GetData = async () => {
      try {
        const result = await UserService.getSucursales();
        if (result) {
          setData(result.data);
        } else {
          props.history.push(process.env.PUBLIC_URL + "/login");
        }
      } catch (e) {
        props.history.push(process.env.PUBLIC_URL + "/login");
      }
    }
    GetData();
  }, []);

  const bodyEliminar = (
    <div className={styles.modal}>
      <p>Estás seguro que deseas eliminar la Sucursal <b>{consolaSeleccionada && consolaSeleccionada.nombre}</b> ? </p>
      <div align="right">
        <Button color="secondary" onClick={() => peticionDelete()} >Sí</Button>
        <Button onClick={() => abrirCerrarModalEliminar()}>No</Button>
      </div>
    </div>
  )

  const inicio = () => {
    props.history.goBack();
  }

  const seleccionarQR = (id) => {
    setUrl(id.urlqr);
    abrirCerrarModalQR()
  }

  const abrirCerrarModalQR = () => {
    setModalQR(!modalQR);
  }

  const bodyQR = (
    <div className={styles.modal}>
      <QRModal url={url} />
    </div>
  )

  return (
    <Paper className={classes.root}>

      <AppBar style={{ background: '#004F9E', alignItems: 'center' }} position="static">
        <Toolbar>
          {isLoading && <CircularProgress color="secondary" />}

          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon style={{ color: '#fff' }} onClick={() => inicio()} />
          </IconButton>
          <Typography variant="h5" component="div" style={{ color: '#fff' }} sx={{ flexGrow: 1 }}>
            Sucursales
          </Typography>
        </Toolbar>
      </AppBar>
      <br />

      {
        (showOwner || (
          OwnedProducts.find(product => product.name === "Mantenimiento").modules.find(
            module => module.name === "Sucursales" && (module.permissions.agregar)
          )
        )) &&
        <Breadcrumbs aria-label="breadcrumb">
          <Button style={{ color: "#fff", backgroundColor: "#004F9E" }} variant="contained" onClick={() => abrirCerrarModalInsertar()}>Nueva Sucursal</Button>
        </Breadcrumbs>
      }

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <div style={{ maxWidth: "100%", direction }}>
            <Grid container>
              <Grid item xs={12}>

                <MaterialTable
                  title=""

                  localization={{
                    toolbar: {
                      searchPlaceholder: 'Buscar...'
                    },
                    header: {
                      actions: 'Acciones'
                    },
                    body: {
                      editRow: {
                        deleteText: 'Estas seguro de eliminar este registro ?'
                      }
                    },


                  }}

                  columns={[
                    {
                      title: 'Sucursal',
                      field: 'nombre',
                    },
                    {
                      title: 'Codigo',
                      field: 'codigo',
                    },
                  ]}
                  data={data}
                  actions={[
                    {
                      icon: () => <Icon path={mdiQrcode}
                        size={1}
                        horizontal
                        vertical
                        rotate={180}
                        color="#cd561c"
                      />,
                      tooltip: 'Ver QR',
                      onClick: (event, data) => seleccionarQR(data),
                    },
                    {
                      icon: 'edit',
                      tooltip: 'Editar',
                      onClick: (event, data) => seleccionarConsola(data, 'Editar'),
                    },
                    {
                      icon: 'delete',
                      tooltip: 'Eliminar',
                      onClick: (event, data) => seleccionarConsola(data, 'Eliminar'),
                    }
                  ]}
                  options={{
                    headerStyle: {
                      backgroundColor: '#004F9E',
                      color: '#FFF',
                    },
                    search: true,
                    actionsColumnIndex: -1
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>

      <Modal
        open={modalEliminar}
        onClose={abrirCerrarModalEliminar}>
        {bodyEliminar}
      </Modal>

      <Modal
        open={modalQR}
        onClose={abrirCerrarModalQR}>
        {bodyQR}
      </Modal>

    </Paper>
  );
}